import React from 'react';

interface FooterProps {
  language: 'es' | 'en';
}

export default function Footer({ language }: FooterProps) {
  const content = {
    es: {
      tagline: 'Tu primer paso en Japón, acompañado',
      services: 'Servicios',
      servicesList: [
        'Municipal Pack',
        'Life Start Pack',
        'Premium Step Pack',
        'Asesoría personalizada'
      ],
      contact: 'Contacto',
      contactInfo: [
        'WhatsApp: +54 11 4025-6200',
        'Email: firstepjp@gmail.com',
        'Osaka, Japan'
      ],
      social: 'Síguenos',
      copyright: '© 2024 First Step Japan. Todos los derechos reservados.',
      poweredBy: 'Website Builder'
    },
    en: {
      tagline: 'Your new beginning in Japan',
      services: 'Services',
      servicesList: [
        'Municipal Pack',
        'Life Start Pack',
        'Premium Step Pack',
        'Custom consultation'
      ],
      contact: 'Contact',
      contactInfo: [
        'WhatsApp: +54 11 4025-6200',
        'Email: firstepjp@gmail.com',
        'Osaka, Japan'
      ],
      social: 'Follow us',
      copyright: '© 2024 First Step Japan. All rights reserved.',
      poweredBy: 'Website Builder'
    }
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-red-600 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <span className="text-red-600 text-xl">🐾</span>
              </div>
              <div>
                <h3 className="font-bold text-lg" style={{ fontFamily: 'Pacifico, serif' }}>
                  First Step Japan
                </h3>
              </div>
            </div>
            <p className="text-red-100 text-sm leading-relaxed">
              {content[language].tagline} 🇯🇵
            </p>
            <div className="flex space-x-4 mt-4">
              <span className="text-2xl">🏯</span>
              <span className="text-2xl">🌸</span>
              <span className="text-2xl">⛩️</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4">{content[language].services}</h4>
            <ul className="space-y-2">
              {content[language].servicesList.map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-red-100 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">{content[language].contact}</h4>
            <ul className="space-y-2">
              {content[language].contactInfo.map((info, index) => (
                <li key={index} className="text-red-100 text-sm">
                  {info}
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-bold text-lg mb-4">{content[language].social}</h4>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-red-500 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-red-100 text-sm">
            {content[language].copyright}
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-100 hover:text-white text-sm transition-colors mt-4 md:mt-0"
          >
            {content[language].poweredBy}
          </a>
        </div>
      </div>
    </footer>
  );
}
